module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_purpose_school_blue-6f2d71b0e982912632114b0e267d237e.svg";